<button
  [class.active]="active"
  [disabled]="disabled"
  [ngClass]="[iconSize, typeClass, sizeClass]"
  class="button"
  type="button"
>
  <ng-container *ngIf="icon">
    <svg-icon [class]="icon" [src]="iconPath" class="icon"></svg-icon>
  </ng-container>
  <span *ngIf="text">{{ text }}</span>
  <ng-content></ng-content>

  <ng-container *ngIf="iconRight">
    <svg-icon [src]="iconRightPath" class="icon-right"></svg-icon>
  </ng-container>
  <svg-icon *ngIf="arrow" class="arrow" src="/assets/icons/icons-arrow-down.svg"></svg-icon>
  <span *ngIf="arrowRight" class="arrow-right">&nbsp;&nbsp;-></span>
</button>
